<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-modal v-model="isVisible" :modalSize="modalSize">
        <div slot="header">
          <h4 class="modal-title">
            Address
          </h4>
          <span
            class="badge custom-badge"
            :class="validated ? 'bg-success' : 'bg-danger'"
          >{{ validated ? 'Validated' : 'Not Validated' }}</span>
        </div>
        <div slot="body">
          <contact-summary
            class="mb-4"
            :contact="value"
          />
          <div class="row">
            <div :class="!fetchedValidAddress ? 'col-md-12' : 'col-md-6'">
              <div class="form-control custom-form">
                <dt-select
                  v-model="addressType"
                  label="Address Type"
                  name="addressType"
                  :options="lookups['AddressType']"
                  validate="required"
                />
                <div class="row">
                  <div class="col-md-6">
                  <dt-input
                    v-model="addressLine1"
                    name="AddressLine1"
                    label="Address Line 1"
                    validate="required"
                  />
                  </div>
                  <div class="col-md-6">
                  <dt-input
                    v-model="addressLine2"
                    name="AddressLine2"
                    label="Address Line 2"
                  />
                  </div>
                </div>
                <dt-input
                  v-model="city"
                  name="City"
                  label="City"
                  validate="required"
                />
                <dt-select
                  v-model="stateProvince"
                  label="State"
                  name="stateProvince"
                  :options="lookups['StateProvince']"
                  validate="required"
                />
                <dt-input
                  v-model="postalCode"
                  name="PostalCode"
                  label="Postal Code"
                  validate="required"
                />
                <dt-select
                  v-model="country"
                  label="Country"
                  name="country"
                  :options="lookups['Country']"
                  validate="required"
                />
                <dt-input
                  v-model="latitude"
                  name="Latitude"
                  label="Latitude"
                  :disabled="true"
                  validate="required"
                />
                <dt-input
                  v-model="longitude"
                  name="Longitude"
                  label="Longitude"
                  :disabled="true"
                  validate="required"
                />
                <dt-textarea
                  v-model="addressNote"
                  name="AddressNote"
                  label="Notes"
                />
              </div>
            </div>
            <div v-if="fetchedValidAddress" class="col-md-6">
              <div class="validated-address-display">
                <h5>Validated Address</h5>
                <p><strong>Address Line 1:</strong> {{ validatedAddress.addressLines }}</p>
                <p v-if="addressLine2"><strong>Address Line 2:</strong> {{ addressLine2 }}</p>
                <p><strong>City:</strong> {{ validatedAddress.city }}</p>
                <p><strong>State:</strong> {{ validatedAddress.stateProvince }}</p>
                <p><strong>Postal Code:</strong> {{ validatedAddress.postalCode }}</p>
                <p><strong>Country:</strong> {{ validatedAddress.country }}</p>
                <p><strong>Latitude:</strong> {{ validatedAddress.latitude }}</p>
                <p><strong>Longitude:</strong> {{ validatedAddress.longitude }}</p>
              </div>
              <br>
              <p>Is this correct?</p>
              <button
                  type="button"
                  class="btn btn-primary"
                  @click="confirmAddress"
              >
                  Confirm
              </button>
            </div>
          </div>
        </div>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="validated"
            @click="validate()"
          >Validate</button>
          <button
            type="button"
            class="btn btn-light"
            @click="close()"
          >Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
            @click="save()"
          >Save</button>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import DtTextarea from '@/components/utilities/form/dt-textarea'
import ContactSummary from '@/components/contacts/forms/contact-summary'
const azureMapKey = window.config ? window.config.azureMapKey : ''
export default {
  name: 'contact-address',
  components: {
    DtModal,
    DtInput,
    DtSelect,
    DtTextarea,
    ContactSummary
  },
  props: {
    value: {
      type: Object
    },
    address: {
      type: Object,
      default() {
        return {
          firm: 0,
          contact: 0,
          contactAddress: 0,
          address: 0,
          addressType: 0,
          addressLines: '',
          city: '',
          stateProvince: 0,
          postalCode: '',
          country: 0,
          addressNote: '',
          latitude: 0,
          longitude: 0,
          validated: false
        }
      }
    },
    validatedAddress: {
      type: Object,
      default() {
        return {
          firm: 0,
          contact: 0,
          contactAddress: 0,
          address: 0,
          addressType: 0,
          addressLines: '',
          city: '',
          stateProvince: 0,
          postalCode: '',
          country: 0,
          addressNote: '',
          latitude: 0,
          longitude: 0,
          validated: false
        }
      }
    }
  },
  data() {
    return {
      // Needing to add this because new addresses don't have a validated property which the "validated" badge can react to
      newAddressValidated: false
    }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    fetchedValidAddress() {
      return this.validatedAddress !== null && this.validatedAddress.addressLines !== ''
    },
    modalSize() {
      let size = ''
      if (this.fetchedValidAddress) {
        size = 'modal-wide'
      }
      return size
    },
    addressType: {
      get() {
        return this.address !== null ? this.address.addressType : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressType',
          value: parseInt(value)
        })
      }
    },
    addressLine1: {
      get() {
        if (this.address !== null && this.address.addressLines) {
          const addressLines = this.address.addressLines.split(',')
          return addressLines[0] || ''
        }
        return ''
      },
      set(value) {
        let addressLines = this.address !== null && this.address.addressLines !== null ? this.address.addressLines.split(',') : []
        if (addressLines.length === 0) {
          addressLines.push(value.replace(',', ''))
        } else {
          addressLines[0] = value.replace(',', '')
        }
        if (addressLines.length < 2) {
          addressLines.push('')
        }
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressLines',
          value: addressLines.join(',')
        })
        this.validated = false
      }
    },
    addressLine2: {
      get() {
        if (this.address !== null && this.address.addressLines) {
          const addressLines = this.address.addressLines.split(',')
          return addressLines[1] || ''
        }
        return ''
      },
      set(value) {
        let addressLines = this.address !== null && this.address.addressLines !== null ? this.address.addressLines.split(',') : []
        if (addressLines.length < 2) {
          addressLines[0] = addressLines[0] || ''
          addressLines.push(value.replace(',', ''))
        } else {
          addressLines[1] = value.replace(',', '')
        }
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressLines',
          value: addressLines.join(',')
        })
        this.validated = false
      }
    },
    city: {
      get() {
        return this.address !== null ? this.address.city : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'city',
          value: value
        })
        this.validated = false
      }
    },
    stateProvince: {
      get() {
        return this.address !== null ? this.address.stateProvince : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'stateProvince',
          value: parseInt(value)
        })
        this.validated = false
      }
    },
    postalCode: {
      get() {
        return this.address !== null ? this.address.postalCode : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'postalCode',
          value: value
        })
        this.validated = false
      }
    },
    country: {
      get() {
        return this.address !== null ? this.address.country : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'country',
          value: parseInt(value)
        })
        this.validated = false
      }
    },
    addressNote: {
      get() {
        return this.address !== null ? this.address.addressNote : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressNote',
          value: value
        })
      }
    },
    latitude: {
      get() {
        return this.address !== null ? parseFloat(this.address.latitude).toFixed(5) : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'latitude',
          value: value
        })
      }
    },
    longitude: {
      get() {
        return this.address !== null ? parseFloat(this.address.longitude).toFixed(5) : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'longitude',
          value: value
        })
      }
    },
    validated: {
      get() {
        if (this.isNewAddress) {
          return this.newAddressValidated
        } else {
          return this.address !== null ? this.address.validated : false
        }
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'validated',
          value: value
        })
        if (this.isNewAddress && value) {
          this.newAddressValidated = true
        }
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isNewAddress() {
      if (this.address.address === -1) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['setItem', 'removeAddress', 'fetchValidatedAddresses']),
    // TODO RC 1.4.24 - I might be able to move this to the store
    confirmAddress() {
      this.addressLines = this.validatedAddress.addressLines + ', ' + this.addressLine2
      this.city = this.validatedAddress.city
      this.stateProvince = this.lookups['StateProvince'].find(x => x.name === this.validatedAddress.stateProvince).value
      this.postalCode = this.validatedAddress.postalCode
      this.country = this.lookups['Country'].find(x => x.name === this.validatedAddress.country).value
      this.latitude = this.validatedAddress.latitude
      this.longitude = this.validatedAddress.longitude
      this.validated = true
      this.$emit('confirmed')
    },
    close() {
      if (this.address.contactAddress === -1) {
        this.removeAddress(-1)
      }
      this.newAddressValidated = false
      this.$emit('closing')
    },
    async validate() {
      let data = {
        address: this.address,
        key: azureMapKey
      }
      this.fetchValidatedAddresses(data)
    },
    async save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$emit('send', this.address.contactAddress)
        }
      })
    },
    submit() {}
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 450px;
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-badge {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/address.vue